function getPrivateKey(): string {
    const key = import.meta.env.VITE_PRIVATE_KEY as string;
    
    if (!key) {
        throw new Error('Invalid private key');
    }
    
    return key;
}

export const PRIVATE_KEY: string = getPrivateKey()
